import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeForMultipleBounds,
  alternativeOffersHelTku,
  orderEligibilitiesMockNotEligibleToRefundForSingleBound,
  orderForDisruptedMultiBounds,
  orderForMultiDisruptedBounds,
  orderForMultipleBoundAcknowledged,
  orderForMultipleBoundHelToTkuAcknowledged,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const disruptedMultiBoundsMock: MockMap = {
  retrieveOrder: [createMockData(orderForDisruptedMultiBounds, [], [flightDisruptionWarning])],
  getOrderEligibilities: [],
  getAlternativeOffers: [createMockData(alternativeOffersHelTku)],
  acknowledge: [createMockData({})]
};

export const multiDisruptedBoundsMock: MockMap = {
  retrieveOrder: [createMockData(orderForMultiDisruptedBounds, [], [flightDisruptionWarning]),
    createMockData(orderForMultipleBoundAcknowledged)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])],
  acknowledge: [createMockData(acknowledgeForMultipleBounds)]
};

export const multiDisruptedBoundsAcknowledgeOneByOneMock: MockMap = {
  retrieveOrder: [createMockData(orderForMultiDisruptedBounds, [], [flightDisruptionWarning]),
    createMockData(orderForMultipleBoundHelToTkuAcknowledged),
    createMockData(orderForMultipleBoundAcknowledged)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])],
  acknowledge: [createMockData(acknowledgeForMultipleBounds)]
};

export const multiBoundSingleBoundDisruptedMock: MockMap = {
  retrieveOrder: [createMockData(orderForMultiDisruptedBounds, [], [flightDisruptionWarning]),
    createMockData(orderForMultipleBoundHelToTkuAcknowledged),
    createMockData(orderForMultipleBoundAcknowledged)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])],
  acknowledge: [createMockData(acknowledgeForMultipleBounds)]
};
